<script setup lang="ts">
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import 'vue-sonner/style.css'

useUTMTracking()
</script>

<template>
  <TooltipProvider>
    <Toaster position="top-right" />
    <BaseGlobalAlertDialog />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </TooltipProvider>
</template>
